<script setup lang="ts">
import UIKit from '@pocketprep/ui-kit'

const {
    Icon,
} = UIKit

withDefaults(defineProps<{
    currentStep: number
    isFreeExam?: boolean
    isShowingLicenseFields?: boolean
}>(), {
    isFreeExam: false,
    isShowingLicenseFields: false,
})

const emit = defineEmits<{
    'back': []
}>()

const emitBack = () => {
    emit('back')
}
</script>

<template>
    <div class="purchase-seats-modal-head">
        <div class="purchase-seats-modal-head__left">
            <img
                v-if="currentStep === 1"
                class="purchase-seats-modal-head__logo purchase-seats-modal-head__logo"
                src="@/assets/upgradeModal/logo.svg"
                alt="Pocket Prep Logo"
            >
            <div
                v-else
                class="purchase-seats-modal-head__back"
                tabindex="0"
                role="button"
                aria-label="Back"
                @keydown.enter="emitBack"
                @click="emitBack"
                @mousedown.prevent
            >
                <Icon type="arrow" />
            </div>
        </div>
        <div class="purchase-seats-modal-head__steps">
            <div
                class="purchase-seats-modal-head__step"
                :class="{
                    'purchase-seats-modal-head__step--active': currentStep === 1,
                    'purchase-seats-modal-head__step--complete': currentStep > 1,
                }"
                tabindex="-1"
                :aria-label="`${currentStep === 1
                    ? 'Current '
                    : ''
                }Step 1 Add Exam Prep`"
            >
                <span v-if="currentStep <= 1" aria-hidden="true">1</span>
                <span v-else-if="currentStep > 1" aria-hidden="true"><Icon type="check" /></span>
                <div aria-hidden="true">
                    <div>
                        Add Exam Prep
                    </div>
                </div>
            </div>
            <div
                class="purchase-seats-modal-head__step"
                :class="{ 'purchase-seats-modal-head__step--active': currentStep === 2 }"
                tabindex="-1"
                :aria-label="`${currentStep === 2
                    ? 'Current '
                    : ''
                }Step 2 Add Payment`"
            >
                <span aria-hidden="true">2</span>
                <div aria-hidden="true">
                    <div>
                        Add Payment
                    </div>
                </div>
            </div>
        </div>
        <div class="purchase-seats-modal-head__links" />
    </div>
</template>

<style lang="scss" scoped>
.purchase-seats-modal-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    &__logo {
        height: 27px;
    }

    &__steps {
        display: flex;
    }

    &__step {
        font-size: 13px;
        line-height: 21px;
        color: $slate-01;
        margin-right: 32px;
        position: relative;

        &::after {
            content: '';
            right: -19px;
            top: 6px;
            width: 5px;
            height: 8px;
            position: absolute;
            background: url('@/assets/upgradeModal/stepper.svg') no-repeat center center;
        }

        &:last-child {
            margin-right: 0;

            &::after {
                display: none;
            }
        }

        span {
            font-weight: 700;
            width: 16px;
            margin: 0 0 0 2px;
            display: inline-block;
        }

        div {
            display: inline-block;
        }

        &--active {
            color: $brand-black;
            font-weight: 600;

            span {
                color: $brand-blue;
            }
        }

        &--complete {
            span {
                margin: 0 2px 0 0;

                svg {
                    width: 16px;
                    height: 13px;
                }
            }

            div {
                text-decoration: line-through;
            }
        }
    }

    &__left {
        display: flex;
        width: 190px;
    }

    &__back {
        color: $brand-blue;
        cursor: pointer;
        outline: none;
        position: relative;
        display: flex;
        align-items: center;

        &:hover,
        &:focus {
            color: $brand-black;
        }

        &:focus::before {
            content: "";
            border: 1px solid $brand-black;
            width: 27px;
            height: 26px;
            top: -6px;
            left: -4px;
            border-radius: 4px;
            box-sizing: border-box;
            position: absolute;
        }

        svg {
            transform: rotate(180deg);
            width: 19px;
            height: 14px;
        }
    }

    &__links {
        font-size: 14px;
        line-height: 19px;
        width: 190px;
        text-align: right;
        position: relative;
        right: 76px;
    }
}
</style>
